var _style, _defs, _g, _defs2, _path, _circle, _g2, _g3, _g4, _g5, _ellipse, _polygon, _ellipse2, _circle2, _circle3, _g6, _g7, _path2, _path3, _path4, _circle4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _line, _path26, _rect, _g8, _path27, _rect2, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g9, _g10, _path42, _path43, _path44, _path45, _path46, _path47, _polygon2, _path48, _path49, _polygon3, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _rect3, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _polygon4, _path87;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1288.2 544.6",
    style: {
      enableBackground: "new 0 0 1288.2 544.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000042016049611095293530000002518127133353088419_);}\n\t.st1{fill:#1193AD;}\n\t.st2{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{mask:url(#SVGID_00000043447606748383928540000006393308275333014941_);}\n\t.st4{fill:#0B545E;}\n\t.st5{opacity:0.29;fill:none;stroke:#FBFFFF;stroke-width:1.13;stroke-miterlimit:10;enable-background:new    ;}\n\t.st6{opacity:0.39;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st8{opacity:0.54;}\n\t.st9{opacity:0.38;fill:#FBFFFF;enable-background:new    ;}\n\t.st10{fill:#FBFFFF;}\n\t.st11{opacity:0.5;}\n\t.st12{opacity:0.3;fill:#FBFFFF;enable-background:new    ;}\n\t.st13{fill:#53BBD3;}\n\t.st14{opacity:0.53;fill:none;stroke:#FFFFFF;stroke-width:0.71;stroke-miterlimit:10.0002;enable-background:new    ;}\n\t.st15{fill:none;stroke:#D8E1EF;stroke-width:0.71;stroke-miterlimit:10;}\n\t.st16{opacity:0.38;}\n\t.st17{opacity:0.74;}\n\t.st18{fill:#92D5E4;}\n\t.st19{fill:#B9E5EE;}\n\t.st20{opacity:0.15;fill:#FFFFFF;enable-background:new    ;}\n\t.st21{fill:#8B8988;}\n\t.st22{fill:none;}\n\t.st23{opacity:0.3;}\n\t.st24{fill:#FFFFFF;}\n\t.st25{fill:#C1C1C1;}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#DDDDDD;}\n\t.st27{fill:#F0EFED;}\n\t.st28{fill:#AAAAAA;}\n\t.st29{fill:#DDDDDD;}\n\t.st30{opacity:0.8;}\n\t.st31{fill:#8C5F51;}\n\t.st32{fill:#3E4148;}\n\t.st33{fill:#DADDEE;}\n\t.st34{fill:#394762;}\n\t.st35{fill:#9E6E5F;}\n\t.st36{fill:#393939;}\n\t.st37{fill:#1192AC;}\n\t.st38{fill:#7FA0E4;}\n\t.st39{fill:#724E44;}\n\t.st40{fill:#9C9FAA;}\n\t.st41{fill:#DBA585;}\n\t.st42{fill:#807F7D;}\n\t.st43{fill:#393D3F;}\n\t.st44{fill:#9BE2F0;}\n\t.st45{fill:#E6D8D1;}\n\t.st46{fill:#DCA787;}\n\t.st47{fill:#CE2F00;}\n\t.st48{fill:#BA2402;}\n\t.st49{fill:#DEDFE6;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 34.8,
    width: 1246.3,
    height: 510
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133492017589409436470000012351573494982889117_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000133492017589409436470000012351573494982889117_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-2.7,235.9c0,0,101.9-201.1,312.1-201.1c232.7,0,269.9,235,336.9,328c136.5,176.5,505.5,78.6,593.8,182 c-2.8,0,1.8,30-2.3,30.1c-153.9,1.7-1236.6,4.5-1285.9,4.5c0-70,23.4-299.3,23.4-342.5C-24.7,231.1-2.7,235.9-2.7,235.9z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -48.1,
    y: 34.8,
    width: 1288.2,
    height: 544.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -48.1,
    y: 34.8,
    width: 1288.2,
    height: 544.6,
    id: "SVGID_00000018938327025867181540000014154768095182071441_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1294,
    height: 549,
    xlinkHref: "133368AC0647B14F.jpg",
    transform: "matrix(1 0 0 1 -51 32.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#SVGID_00000018938327025867181540000014154768095182071441_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-2.7,235.9c0,0,101.9-201.1,312.1-201.1c232.7,0,269.9,235,336.9,328c136.5,176.5,505.5,78.6,593.8,182 c-2.8,0,1.8,30-2.3,30.1c-153.9,1.7-1236.6,4.5-1285.9,4.5c0-70,23.4-299.3,23.4-342.5C-24.7,231.1-2.7,235.9-2.7,235.9z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 76.6,
    cy: 248.7,
    r: 14.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 273.5,
    cy: 135.7,
    r: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "264.9,132.4 270.6,132.4 270.6,126.6 276.4,126.6 276.4,132.4 282.1,132.4 282.1,138.1 276.4,138.1  276.4,143.8 270.6,143.8 270.6,138.1 264.9,138.1  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M209.2,167.5l-2.4,1.2c-2.8,1.4-6.2,0.2-7.6-2.6l-10.8-22.3c-1.7-3.5-0.3-7.7,3.2-9.4c0,0,0,0,0.1,0l0,0 c3.5-1.7,7.7-0.3,9.4,3.2c0,0,0,0,0,0.1l10.8,22.3C213.2,162.7,212,166.1,209.2,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M193.3,153.8l5.2,10.8c1.7,3.5,5.8,5.1,9.4,3.5c3.5-1.6,5-5.8,3.4-9.3c0,0,0-0.1-0.1-0.1l-5.3-11l0,0 L193.3,153.8L193.3,153.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 554.8,
    cy: 257.5,
    r: 15.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "546.2,254.1 551.9,254.1 551.9,248.4 557.6,248.4 557.6,254.1 563.3,254.1 563.3,259.8 557.6,259.8  557.6,265.5 551.9,265.5 551.9,259.8 546.2,259.8  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M441.6,151.8H426c-3.4,0-6.2-2.8-6.2-6.2l0,0v-27.4h28v27.3C447.9,149,445.1,151.8,441.6,151.8 C441.7,151.8,441.6,151.8,441.6,151.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.1,
    y: 112.6,
    className: "st7",
    width: 32.1,
    height: 5.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 419.7,
    y1: 124.9,
    x2: 448.2,
    y2: 124.9
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -20.2532 200.3966)",
    className: "st12",
    cx: 493.6,
    cy: 151.1,
    rx: 25.7,
    ry: 25.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "507.4,149.4 495.9,149.2 496,137.7 491.4,137.7 491.3,149.2 479.8,149.1 479.7,153.6 491.3,153.7  491.2,165.3 495.7,165.3 495.8,153.8 507.4,153.9 "
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2452 -0.9695 0.9695 0.2452 -45.4028 250.0836)",
    className: "st14",
    cx: 137.9,
    cy: 154.2,
    rx: 33.1,
    ry: 33.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 110.4,
    cy: 141.3,
    r: 15.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 344.9,
    cy: 163,
    r: 17.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M227.1,137.8c-0.2,0-0.4,0-0.5-0.1c-2.6-1.2-5-2.8-7.1-4.8c-2.2-2-3.4-4.9-3.4-7.8c0.1-3,2.3-5.9,5.2-6.3 c2.9-0.3,5.5,1.7,6,4.6c0.7-3,3.6-4.8,6.6-4.1c1.8,0.4,3.3,1.8,4,3.5c0.5,1.4,0.5,3,0,4.4c-1.4,4.8-5.7,8.3-10.2,10.5 C227.5,137.8,227.3,137.8,227.1,137.8L227.1,137.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M44.3,239.3l-1.5,1.5c-1.8,1.9-4.8,1.9-6.7,0.1l-14.7-14.1c-2.3-2.2-2.4-5.9-0.1-8.2l0,0 c2.2-2.3,5.9-2.4,8.2-0.1l0,0l14.7,14.2C46,234.5,46.1,237.4,44.3,239.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M28.1,233.2l7.1,6.9c2.3,2.3,6,2.3,8.3,0.1c2.3-2.3,2.3-5.9,0-8.2c0,0,0,0-0.1-0.1l-7.2-7l0,0L28.1,233.2 L28.1,233.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M400.7,134.1h-10.1c-0.9,0-1.6-0.7-1.6-1.6v-10.1c0-0.9-0.7-1.6-1.6-1.6h-0.2c-0.9,0-1.6,0.7-1.6,1.6l0,0v10.1 c0,0.9-0.7,1.6-1.6,1.6h-10.1c-0.9,0-1.6,0.7-1.6,1.6l0,0v0.2c0,0.9,0.7,1.6,1.6,1.6l0,0H384c0.9,0,1.6,0.7,1.6,1.6l0,0v10.1 c0,0.9,0.7,1.6,1.6,1.6l0,0h0.2c0.9,0,1.6-0.7,1.6-1.6l0,0v-10.1c0-0.9,0.7-1.6,1.6-1.6l0,0h10.1c0.9,0,1.6-0.7,1.6-1.6l0,0v-0.2 C402.4,134.8,401.7,134.1,400.7,134.1C400.8,134.1,400.8,134.1,400.7,134.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M372.4,116h-6.1c-0.6,0-1-0.4-1-1v-6.1c0-0.6-0.4-1-1-1h-0.2c-0.6,0-1,0.4-1,1v6.1c0,0.6-0.4,1-1,1H356 c-0.6,0-1,0.4-1,1v0.2c0,0.6,0.4,1,1,1h6.1c0.6,0,1,0.4,1,1v6.1c0,0.6,0.4,1,1,1h0.2c0.6,0,1-0.4,1-1v-6.1c0-0.6,0.4-1,1-1h6.1 c0.6,0,1-0.4,1-1V117C373.4,116.5,373,116,372.4,116L372.4,116z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M42.5,203.9h6.7c0.6,0,1.1,0.6,1.1,1.2v7.1c0,0.7,0.5,1.2,1.2,1.2l0,0c0.7,0,1.2-0.6,1.2-1.2l0,0v-7.1 c0-0.7,0.5-1.2,1.2-1.2l0,0h6.7c0.7,0,1.2-0.6,1.2-1.2l0,0l0,0c0-0.7-0.5-1.2-1.1-1.2l0,0H54c-0.7,0-1.2-0.6-1.2-1.2V193 c0-0.6-0.5-1.2-1.1-1.2l0,0c-0.7,0-1.2,0.5-1.2,1.2v7.1c0,0.7-0.5,1.2-1.2,1.2h-6.7c-0.7,0-1.2,0.5-1.2,1.2l0,0l0,0 C41.3,203.3,41.8,203.8,42.5,203.9L42.5,203.9z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 323.2,
    cy: 133.2,
    r: 8.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M118.5,346.1c-5.2-12.1-10.8-24.9-21.2-33.5c-5.3-4.4-11.8-7.2-17.5-11.1c-6.4-4.4-11.9-10.2-16-16.8 c-0.3-0.5-1.2,0-0.9,0.5c3.6,5.8,8.2,10.9,13.6,15.1c5.6,4.5,12.3,7.3,18.1,11.4c11.7,8.2,17.6,22.2,23.1,34.9 C117.8,347.2,118.7,346.7,118.5,346.1L118.5,346.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M68.2,291.3c-1.6-5.7-3.5-11.9-8.2-14.9c-0.9-0.6-1.9-0.9-3-0.9c-1.1,0.1-1.9,1-2,2.1c0,0.7,0.2,1.5,0.6,2.1 c2.8,5.4,8,8.6,12.9,11.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M74.3,297.3c-2.7-1.3-5.6-2-8.6-2c-1.6-0.1-3.1,0.3-4.3,1.3c-1.2,1.2-1.4,3.1-0.4,4.5c1.1,1.2,2.8,1.2,4.2,0.9 c3.5-0.6,6.9-1.7,10-3.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M81.1,302.7c-2.9-3.7-4.7-8.3-5-13c-0.3-1.5-0.1-3,0.5-4.3c0.6-1.1,2-1.6,3.1-1c0.1,0.1,0.3,0.2,0.4,0.2 c0.6,0.8,1,1.8,1,2.9c0.6,5,1,11.3,1.1,16.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M90.3,308.3c-4.2-2.1-9.1-1.8-13.1,0.6c-1.1,0.6-1.9,1.6-2.3,2.8c-0.4,1.3,0.2,2.7,1.4,3.4 c0.8,0.2,1.6,0.2,2.3-0.2c4.2-1.5,8.1-3.7,11.7-6.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M93.7,310.1c-2.7-4.6-4-9.9-3.9-15.3c-0.1-0.5,0.1-1,0.4-1.4c0.8-0.7,1.9,0.5,2.4,1.5 c2.4,4.7,2.9,11.6,2.3,16.7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M99.5,315.8c-3-1-6.3,0-8.3,2.4c-0.6,0.8-1.1,2.1-0.4,3c0.6,0.6,1.4,0.8,2.1,0.6c2.8-0.3,6-2.9,8.2-4.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M130.3,428.4l-9.5-39.7c-0.3-1.5-1.9-2.5-3.4-2.1c-0.9,0.2-1.6,0.8-2,1.7c-2.4,6.5-2.6,13.7-0.8,20.4 c-8.2-5.3-5.7-10.4-5.9-20.1c-0.1-7.7-3.3-30-7.6-36c-1.7-2.5-5.4-4.2-6.6-1.5c-2.7,6-2,9.7-1,16.2c-4.2-12.5-4.6-8.9-8.6-22.3 c-0.9-2.9-1.9-10.1-2.9-12.9c-1.3-3.6-6.3-4-7.9-0.6c-1.8,3.8-2.8,8-3,12.2c-2.5-13.8-6.1-29.2-18.1-37c-2.5-1.6-5.6-2.9-8.6-0.5 c-1.3,1-2.2,2.3-2.6,3.8c-1.1,3.6,0.1,7.2,1.4,10.6c3.2,8.2,7.8,15.9,13.6,22.6c0.6,0.7,0.5,1.8-0.2,2.3c-0.4,0.3-0.8,0.4-1.3,0.4 c-5.1-0.8-10.8-7.5-15.3-4.7c-2.2,1.5-2.9,4.3-1.7,6.7c2.1,4.3,6.6,5.6,10.7,7.1c9.6,3.5,18.4,9,25.9,16.1c-2.5,0.8-5,1.7-7.4,2.6 c-3.1,1.1-4.8,4.5-3.7,7.6c0.6,1.6,1.8,2.9,3.3,3.6c7.2,3.4,13.6,3.5,19.9,8.8c1,0.8,4.9,3.1,4.1,4.6s-2,1.7-3.5,1.3 c-6.6-1.5-7.5,6.6-4,10c3,2.8,7.4,3.3,11.5,3.6s8.5,0.7,11.6,3.4l-6.6,3.7c-1.6,1-2.2,3.1-1.2,4.7c0.5,0.8,1.3,1.4,2.2,1.6 c3.2,0.8,7,0.6,10.3,0.3c5.7-0.6,12.8-0.2,15.3,5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M101.7,452.4c-16.8-9-35.3-14.2-54.2-15.3c15.6-0.8,31.3,0.2,46.8,2.9c-21.9-13.9-45.6-24.7-70.4-32.1 c21.1,3.6,41.9,9.1,61.9,16.6c-22.2-17.4-45.4-33.6-69.4-48.6c24.4,8.2,47.4,19.8,68.4,34.6c-20.5-24.8-44.4-46.5-71-64.6 c30.4,10.9,58.1,28.3,81.1,51c-5.3-16.1-12.2-31.7-20.5-46.5l63.6,82.1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M514.4,361c4.5-14.4,9.3-29.6,20.8-40c5.8-5.2,12.6-8.9,18.3-14.2c5.5-5.2,10-11.3,13.3-18.1 c0.3-0.6-0.6-1.1-0.9-0.5c-3.5,7.2-8.4,13.6-14.3,19c-6,5.4-13.2,9.3-19,14.9c-10.5,10.2-15,25.1-19.2,38.7 C513.3,361.4,514.3,361.7,514.4,361L514.4,361z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M561.9,295.9c1-6.3,2.4-13.3,7.2-17c0.9-0.8,2-1.3,3.2-1.3s2.2,0.8,2.5,2c0.1,0.8-0.1,1.6-0.4,2.4 c-2.4,6.1-7.7,10.2-12.7,13.9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M555.9,303c2.8-1.7,5.9-2.8,9.2-3.1c1.7-0.3,3.5,0,4.9,0.9c1.5,1.1,1.9,3.2,1,4.8c-1,1.5-2.9,1.6-4.5,1.5 c-3.9-0.3-7.8-1.1-11.5-2.4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M549.1,309.7c2.8-4.4,4.1-9.5,3.9-14.6c0.1-1.6-0.3-3.2-1.1-4.6c-0.8-1.2-2.4-1.5-3.6-0.6 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.6,0.9-0.9,2.1-0.8,3.2c0,5.9,0.3,11.8,0.9,17.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M539.6,316.8c4.4-2.7,9.9-3.1,14.5-0.8c1.3,0.5,2.3,1.5,2.9,2.7c0.6,1.3,0.2,2.9-1,3.8 c-0.8,0.3-1.7,0.4-2.6,0.1c-4.8-1.1-9.5-3-13.7-5.5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M536.2,319.1c2.3-5.3,3.2-11.1,2.4-16.9c0-0.6-0.2-1.1-0.7-1.5c-0.9-0.6-2,0.7-2.5,1.9 c-2,5.3-1.7,12.8-0.4,18.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M530.4,325.9c3.2-1.4,6.9-0.8,9.5,1.6c0.8,0.8,1.5,2.1,0.9,3.1c-0.5,0.7-1.4,1-2.3,0.9c-3.2,0-7-2.4-9.6-4.2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M538.5,452.7c14-6,29.2-8.9,44.4-8.6c-12.5-1.5-25.2-1.7-37.8-0.5c18.4-9.4,38-16.4,58.3-20.6 c-17.1,1.5-34.1,4.6-50.7,9.2c18.8-12.2,38.3-23.3,58.3-33.4c-19.9,4.8-39.1,12.5-56.8,22.7c17.8-18,38.1-33.4,60.3-45.7 c-24.8,6.5-47.9,18.3-67.8,34.6l-15.6-2.4l-12.9,38.7L538.5,452.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M499.5,460.2c3.6-5.6,9.2-10.7,16.2-11.3c7.8-0.7,17.3,3.7,22.8-1.4c2.8-2.8,3.1-7.2,0.8-10.3 c-2.5-3.2-6.7-4.5-10.6-3.2c-0.5-5.2,5.1-8.8,10.3-10.2s11.2-2.2,14.5-6.2s-0.2-12.3-5.4-11c-2,0.5-3.7,2.3-5.7,1.4 c-1.3-0.6-2-2-1.7-3.4c0.5-2.3,2.6-3.5,4.6-4.5l15.1-7.8c4-2,8.2-4.4,9.8-8.5s-1.5-10-6.1-9.7c-3.3,0.2-6.7,3.3-9.3,1.3 c-2.4-1.9-0.6-5.4,1.5-7.4c5.3-4.9,12-8.3,17.2-13.3c5.6-5.4,9.5-13.6,5.7-21c-0.9-1.9-2.4-3.4-4.3-4.3c-4.9-2.2-9.2,1.2-12.3,4.5 c-5.7,6.1-10.5,13-14.2,20.6c-1.5,3.2-6.8,1.8-6.8-1.8v-0.1c0-3.5-2-8.2-5.6-7.5c-1,0.2-1.9,0.8-2.4,1.6c-6.5,9.1,3,20.9,3.8,31.9 c0.2,2.9-0.3,5.9-2.2,8c-2,2.3-5.3,2.8-8,1.3c-2.9-1.8-5.7-6.4-8.2-4.5c-1,0.8-1.4,2.2-0.8,3.4c2.9,7.2,4.3,14.8,4.3,22.6 c0,4.4-0.9,9.2-4.6,11.6s-10.6-0.3-10-4.6c-2.1-0.8-4.2,1-4.6,3s0.4,4.1,1,6.1c2.9,9.5,1.2,19.9-4.6,28"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M61.8,460.5c0,0-70.7-167.3,59-227.5S131.1,400.7,263,392c51.3-3.4,148.6-71.7,119.4-227 C365,72.6,569.7,127.7,603.8,460.4L61.8,460.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M520,436.5H122.4V206.6c0-8,6.5-14.5,14.5-14.5l0,0h368.6c8,0,14.5,6.5,14.5,14.5V436.5L520,436.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M508.7,436.1H133.2V209.8c0-3.4,2.8-6.2,6.2-6.2l0,0h363c3.4,0,6.2,2.8,6.2,6.2L508.7,436.1L508.7,436.1z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 122.6,
    y1: 435.6,
    x2: 520.4,
    y2: 435.6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M524.1,460.5h-404c-7.3,0-13.2-5.9-13.2-13.2l0,0v-5.6c0-3,2.4-5.4,5.3-5.4l0,0h419.7c3,0,5.4,2.4,5.4,5.4v5.6 C537.3,454.5,531.4,460.5,524.1,460.5L524.1,460.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 444.6,
    className: "st21",
    width: 397.6,
    height: 6.8
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.8,220.6h259.3c6,0,10.9,4.9,10.9,10.9c0,0,0,0,0,0.1v171.8c0,6-4.9,10.9-10.9,10.9l0,0H228.8 c-6,0-10.9-4.9-10.9-10.9l0,0V231.5C217.9,225.5,222.8,220.6,228.8,220.6L228.8,220.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M434.6,231.7c-4.1-1.1-8.2,1.4-9.3,5.5c-1.1,4.1,1.4,8.2,5.5,9.3s8.2-1.4,9.3-5.5c0.3-1.2,0.3-2.6,0-3.8 C439.4,234.5,437.3,232.4,434.6,231.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M458.9,231.7c-4.1-1-8.2,1.4-9.3,5.5c-0.3,1.2-0.3,2.5,0,3.8c0.7,2.7,2.8,4.8,5.5,5.5c4.1,1,8.2-1.4,9.3-5.5 C465.5,236.9,463,232.7,458.9,231.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M488.7,241c1-4.1-1.4-8.2-5.5-9.3c-4.1-1-8.2,1.4-9.3,5.5s1.4,8.2,5.5,9.3c1.2,0.3,2.6,0.3,3.8,0 C485.9,245.8,488,243.7,488.7,241"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M234.9,402H482c3,0,5.4-2.4,5.4-5.4l0,0V260.1c0-3-2.4-5.4-5.4-5.4H234.9c-3,0-5.4,2.4-5.4,5.4v136.4 C229.5,399.6,231.9,402,234.9,402L234.9,402"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.3,
    y: 325.4,
    className: "st25",
    width: 126.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.3,
    y: 302.1,
    className: "st25",
    width: 101.8,
    height: 11.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.3,
    y: 278.8,
    className: "st25",
    width: 82.9,
    height: 11.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.3,
    y: 348.7,
    className: "st25",
    width: 126.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.3,
    y: 372,
    className: "st25",
    width: 126.4,
    height: 11.4
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M186,335.6l19.3-12.6v31.9L186,335.6z M142.4,320.5h62.8L173.8,341L142.4,320.5z M142.1,354.9v-32l19.3,12.6 L142.1,354.9z M173.8,343.6L173.8,343.6l10.7-7L203,355h-58.4l18.5-18.5L173.8,343.6z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 264.9,
    className: "st27",
    width: 61.7,
    height: 127.7
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M421,328.2h37.1c4.7,0,8.5-3.8,8.5-8.5l0,0v-8.8c0-4.7-3.8-8.5-8.5-8.5h-29.4c-4.7,0-8.5,3.8-8.5,8.5v16.6 C420.2,327.9,420.6,328.2,421,328.2L421,328.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M426.5,307.9c0,0,2.2-0.1,5.5-0.2c1.6,0,3.5-0.1,5.6-0.1h6.4h6.4c2,0,4,0.1,5.6,0.1c3.3,0.1,5.5,0.2,5.5,0.2 s-2.2,0.1-5.5,0.2c-1.6,0-3.5,0.1-5.6,0.1H444h-6.4c-2,0-4-0.1-5.6-0.1C428.7,308,426.5,307.9,426.5,307.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M426.5,312.7c0,0,2.2-0.1,5.5-0.2c1.6,0,3.5-0.1,5.6-0.1h6.4h6.4c2,0,4,0.1,5.6,0.1c3.3,0.1,5.5,0.2,5.5,0.2 s-2.2,0.1-5.5,0.2c-1.6,0-3.5,0.1-5.6,0.1H444h-6.4c-2,0-4-0.1-5.6-0.1C428.7,312.8,426.5,312.7,426.5,312.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M426.5,317.5c0,0,2.2-0.1,5.5-0.2c1.6,0,3.5-0.1,5.6-0.1h6.4h6.4c2,0,4,0.1,5.6,0.1c3.3,0.1,5.5,0.2,5.5,0.2 s-2.2,0.1-5.5,0.2c-1.6,0-3.5,0.1-5.6,0.1H444h-6.4c-2,0-4-0.1-5.6-0.1C428.7,317.7,426.5,317.5,426.5,317.5z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M426.5,322.4c0,0,1.7-0.1,4.2-0.2c1.2,0,2.7-0.1,4.3-0.1h4.9h4.9c1.6,0,3,0.1,4.3,0.1c2.5,0.1,4.2,0.2,4.2,0.2 s-1.7,0.1-4.2,0.2c-1.3,0-2.7,0.1-4.3,0.1h-4.9H435c-1.6,0-3-0.1-4.3-0.1C428.2,322.5,426.5,322.4,426.5,322.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M466.4,290.5h-40.7c-2.6,0-4.8-2.1-4.8-4.8l0,0v-4.8c0-2.6,2.1-4.8,4.8-4.8h36.2c2.6,0,4.8,2.1,4.8,4.8v9.3 C466.7,290.3,466.6,290.5,466.4,290.5L466.4,290.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M426.5,280.8c0,0,2.2-0.1,5.5-0.2c1.6,0,3.5-0.1,5.6-0.1h6.4h6.4c2,0,4,0.1,5.6,0.1c3.3,0.1,5.5,0.2,5.5,0.2 s-2.2,0.1-5.5,0.2c-1.6,0-3.5,0.1-5.6,0.1H444h-6.4c-2,0-4-0.1-5.6-0.1C428.7,281,426.5,280.8,426.5,280.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M426.5,285.7c0,0,2.2-0.1,5.5-0.2c1.6,0,3.5-0.1,5.6-0.1h6.4h6.4c2,0,4,0.1,5.6,0.1c3.3,0.1,5.5,0.2,5.5,0.2 s-2.2,0.1-5.5,0.2c-1.6,0-3.5,0.1-5.6,0.1H444h-6.4c-2,0-4-0.1-5.6-0.1C428.7,285.8,426.5,285.7,426.5,285.7z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M421.4,354.8h30.9c2.6,0,4.8-2.1,4.8-4.8l0,0v-4.8c0-2.6-2.1-4.8-4.8-4.8h-26.4c-2.6,0-4.8,2.1-4.8,4.8l0,0 v9.3C421.1,354.6,421.3,354.8,421.4,354.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M427,345.1c0,0,1.6-0.1,3.9-0.2l4-0.1c1.5,0,3,0,4.6,0s3.1,0,4.6,0s2.8,0.1,4,0.1c2.3,0.1,3.9,0.2,3.9,0.2 s-1.6,0.1-3.9,0.2c-1.2,0-2.5,0.1-4,0.1s-3,0-4.6,0s-3.1,0-4.6,0l-4-0.1C428.6,345.2,427,345.1,427,345.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M427,349.9c0,0,1.4-0.1,3.4-0.2c1,0,2.2-0.1,3.5-0.1s2.6,0,4,0s2.7,0,4,0s2.5,0.1,3.5,0.1 c2,0.1,3.4,0.2,3.4,0.2s-1.4,0.1-3.4,0.2c-1,0-2.2,0.1-3.5,0.1s-2.6,0-4,0s-2.7,0-4,0s-2.5-0.1-3.5-0.1 C428.4,350,427,349.9,427,349.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M466.6,381.1h-30.9c-2.6,0-4.8-2.1-4.8-4.8l0,0v-4.8c0-2.6,2.1-4.8,4.8-4.8l0,0h26.4c2.6,0,4.8,2.1,4.8,4.8 l0,0v9.3C466.9,381,466.8,381.1,466.6,381.1z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M436.4,371.6c0,0,1.6-0.1,3.9-0.2l4-0.1c1.5,0,3,0,4.6,0s3.1,0,4.6,0s2.8,0.1,4,0.1c2.3,0.1,3.9,0.2,3.9,0.2 s-1.6,0.1-3.9,0.2c-1.2,0-2.5,0.1-4,0.1s-3,0-4.6,0s-3.1,0-4.6,0l-4-0.1C437.9,371.7,436.4,371.6,436.4,371.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M436.4,376.4c0,0,1.6-0.1,3.9-0.2l4-0.1c1.5,0,3,0,4.6,0h4.6c1.5,0,2.8,0.1,4,0.1c2.3,0.1,3.9,0.2,3.9,0.2 s-1.6,0.1-3.9,0.2c-1.2,0-2.5,0.1-4,0.1s-3,0-4.6,0s-3.1,0-4.6,0l-4-0.1C437.9,376.5,436.4,376.4,436.4,376.4z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.3,
    y: 220.8,
    className: "st29",
    width: 65,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.3,
    y: 225.8,
    className: "st24",
    width: 54,
    height: 79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 237.8,
    className: "st1",
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 244.8,
    className: "st1",
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 251.8,
    className: "st1",
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 258.8,
    className: "st1",
    width: 43,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 265.8,
    className: "st1",
    width: 43,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 272.8,
    className: "st1",
    width: 43,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 279.8,
    className: "st1",
    width: 43,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 286.8,
    className: "st1",
    width: 43,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 293.8,
    className: "st1",
    width: 43,
    height: 2
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M189.5,383.6c0-11.2-6-15-11.6-15.8c0,0,0-0.1,0-0.2c-0.1-1.5-1.3-2.6-2.8-2.5c-1.4-0.1-2.7,1.1-2.7,2.5l0,0 c0,0.1,0,0.1,0,0.2c-5.6,0.9-11.7,4.7-11.7,15.9c0,13-3.2,14.4-7.6,18.1h44C192.7,398.1,189.5,396.7,189.5,383.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M175.1,409.1c2.9,0,5.4-2.1,5.9-4.9h-11.8C169.6,407,172.2,409.1,175.1,409.1z"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M530.2,364.6c0.1-0.4,0.1-0.8,0-1.2c0,0-0.3-0.6-0.5-1.1c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.7-0.3-1.4-0.6-2.1 c-1-1.4-2.2-2.7-3.4-4l-2.1,1.1l-2.2,0.8c0,0-0.2,5.9,0.1,6.7c0,0.1,0.1,0.2,0.1,0.2c0.3,0.5,0.7,1,1.1,1.4c0.1,0.1,1,1.3,1.4,1.3 c0.5,0,1-0.2,1.3-0.6c0.6,0,1.3-0.2,1.8-0.5c0.7,0,1.3-0.3,1.7-0.9C528.9,365.3,530,365.3,530.2,364.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M476.1,266.6c0,0-2.8-18.4,12.4-18.1s14.4,14.5,12.6,20.6c-1.4,4.5-3.9,6.2,2.7,18.8 c6.6,12.6-5.7,12.6-5.7,12.6l-9.5-13.1L476.1,266.6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M468.9,332.7l-0.3,0.4l0,0c-0.4,0.4-0.9,1.1-1.6,2c-4.1,4.9-13,15.2-16.4,17.1c-2.4,1.3-2.8-2.8-0.4-5.4 c2.2-2.3,10.6-17.4,13.9-20.6c1.6-1.6,3.7-16.5,3.7-16.5s2,12.4,1.8,13.8S470.3,330.9,468.9,332.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M450.1,346.7c0,0-1.4,1.9-2.1,2.1s-1.6,1.5-2.2,1.9s-2.6,0.6-3.1,1.2c-0.4,0.9-0.8,1.7-1.3,2.5 c-0.5,0.4-1.5,1.2-1.1,1.5s1.5,0,1.5,0c-0.2,0.2-0.3,0.6-0.1,0.9c0.5,0.8,1.1,0.8,1.1,0.8s-0.1,0.7,0.2,1c0.3,0.4,0.7,0.6,1.2,0.6 c0.1,0.3,0.3,0.7,0.6,0.9c0.4,0.3,0.9,0.3,1.4,0.1c0,0,0.7,0.8,1.2,0.6c0.4-0.2,0.8-0.5,1.2-0.9c1.6-1.9,2.8-4.2,3.5-6.6 c0.4-1.8,1.3-3.5,2.4-5L450.1,346.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M441.9,355.5c0,0,2.1-2.8,3.3-2.9s0.5,1,0.5,1s0.7-1.1,1.6-0.6s0,1.6,0,1.6c0.4-0.4,1-0.4,1.4,0.1 c0,0,0,0,0,0.1c0.7,0.8-0.2,1.6-0.2,1.6s1.6-0.4,1.4,0.9c-0.3,1.4-1.2,2.7-2.5,3.4c-0.5,0.2-1.1,0-1.4-0.4c-0.8,0.3-1.7,0-2-0.8 c0-0.1-0.1-0.1-0.1-0.2c0,0-1.8-0.2-1.4-1.6c-0.7-0.1-1.1-0.8-1-1.4C441.6,355.9,441.7,355.7,441.9,355.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M457.4,474.1c0,0-6,10.1-8.5,11.8c-3.4,2.2-1.3,4.5,0.4,4.5s10,0.6,11.8-1.5s2.8-8.3,4.5-10s3.3-7.6-0.8-9.7 C460.1,467,457.4,474.1,457.4,474.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "466.9,476 465.3,488.2 464.5,488.2 464.8,479.4 "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M508.7,464.2c0,0-1.4,11.6-3.1,14.2c-2.2,3.4,0.6,4.7,2.1,4s9.4-3.4,10.2-6.1s-0.8-8.7,0.1-10.9 s-0.1-8.3-4.6-8.5C508.4,456.6,508.7,464.2,508.7,464.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M508.6,458.4c0,0-0.9,14.3-1.3,16.4s2.7,0.7,4.3-0.9c1.6-1.6,3.2-11.5,3.2-13.3c-0.2-1.3-0.7-2.6-1.4-3.7 L508.6,458.4z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "518.2,462.1 521.6,473.9 520.9,474.3 517.6,466.2 "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M483.7,375.4c-0.3,1.4-2.2,7.5-4.3,14.2l0,0c-2,6.1-4.1,12.8-5.4,17c-0.5,1.6-0.8,2.8-1,3.6 c-1.2,5,0.2,12.9,0.6,19.5s-9.1,43.5-9.1,43.5c-1.7,0.8-4.8-4.5-4.8-4.5c1.2-2.4,1-44,0.4-46.6s-1.1-9.7-0.4-12.5 c0.1-0.7,0.2-1.5,0.2-2.2c0-3.5-0.7-9.4-1.1-15.8c-0.6-8,2.6-28.1,3-29.9c0-0.2,0.1-0.4,0.2-0.7c0.8-2.8,3.5-10.8,3.5-10.8 c5.4-1.6,9.4-1.9,12.5-1.3c3.4,0.6,6.2,3,7.3,6.3C487.7,362.6,484.1,373.5,483.7,375.4z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M514,457.9l-5.4,1.9c-0.9-4.5-23-35.8-24.4-39.2c-1.5-4.1-2.4-8.3-2.8-12.6c0-0.4,0-1.2-0.1-2.1 c-0.2-3.7-0.9-10.8-1.9-16.2c-0.2-1-0.4-2-0.6-2.9c-1.1-4.7-1.3-20.9-1.3-30.3c0-4.2,0-7.1,0-7.1s0.1-0.1,0.3-0.2 c2-1.5,15.1-11,19.7-2.2c1.2,2.3,2,4.8,2.5,7.4c1.5,8,0,16.9-1.1,25.1c-1,7-2.9,16.9-3.5,24.2c-0.3,4-0.2,7.3,0.7,8.9 c2.6,4.5,5.1,8.3,10.3,24C508,441.7,514,457.9,514,457.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M508.5,459.8c0,0,2.5,3.3,5.4-1.9C514,457.9,510.8,454.4,508.5,459.8z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M459.6,468.7c0,0-6.5,12.7-7.7,14.5s2.2,1.8,4.3,0.9s7.6-9.3,8.2-10.9c0.4-1.1,0.7-2.3,0.9-3.5L459.6,468.7z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M459.6,468.7c0,0-3.5,6.5,5.7,1C465.3,469.7,463.6,466.8,459.6,468.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M485,251.5c0,0-10.3,1.6-10.7,16.3c-0.4,14.7,2.8,17.8,11.8,14.7c9-3.1,11.9-18.4,12.1-20.8 C498.4,259.4,499,249.8,485,251.5z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M503.2,302.5c0,5-5.8,17.1-6.6,20.9s-2.3,4.9-1.1,9.7s6,21.7,4.7,22.3c-18.9,9.8-35.6,9.2-38.3,5.7 c0,0,6.1-22.8,6.5-25.4s-0.5-12.4-0.8-15.1s-3-8.7-2.9-11.5s1.5-5.2,3.4-8.3c0.6-0.9,1.2-1.9,1.9-2.8c1.5-2.4,3.2-4.6,5.1-6.7 c0.6-0.6,1.3-1.2,2.1-1.6l0,0c0.7-0.5,1.4-0.8,2.1-1.1l8.9-1.4c0,0,5.5,2,8.7,2.8C496.9,289.9,503.1,290.8,503.2,302.5z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M477.2,289.7l-5.1,8.1l-4.7,7.5c0,0,0.3-1.2,0.9-4.5c0.1-0.6,0.2-1.3,0.3-2.1c0-0.2,0.1-0.5,0.1-0.7l0,0 C470.6,293.3,477,289.8,477.2,289.7L477.2,289.7z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M491.9,276c-0.9,1.7-1.8,12.2-1.8,12.2s-12.6,4.8-11.3,2.1c0.5-1.3,0.8-2.7,0.8-4.2c0-0.9,0-1.7-0.1-2.6 c0-0.3,0-0.4,0-0.4S492.8,274.3,491.9,276z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M480.8,262.1c2.5,3,5.4,5.6,8.5,7.9c4.8,3.4,4,10.2,4,10.2s12.6-26.5,0.6-28.3s-19.3-2-19.6,16 C474.3,267.8,479.8,261.9,480.8,262.1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M488,281.7c-1.9,2.9-8.5,4.4-8.5,4.4l0,0c0-0.9,0-1.7-0.1-2.5C483.5,284.4,488,281.7,488,281.7z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M468.7,298L468.7,298c-0.3,0.9-0.5,1.9-0.5,2.9l1.9-2.8c0,0,3.3-4.8,4.5-6c0.8-0.9,1.7-1.6,2.7-2.3 C477.2,289.7,470.6,292.8,468.7,298z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M494.3,307.7c0,0,9.5-4,11.8-4.6c0,0-3.9-14.2-11.9-13.3C485.4,290.7,494.3,307.7,494.3,307.7z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M479.3,288.6c0,0-6,9.1-3.9,9.9s12.9-1.1,17.5-9.7C492.9,288.8,486,285.2,479.3,288.6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M448.7,348.3c0,0,4,2,5,3.7c0,0,7.1-10.2,7.8-10.7l-10.8,4.7L448.7,348.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M521.1,358.1c0,0,4.2-1,5.7-1.1l-6.4-15.2l-2.4,8.6C518,350.3,521.1,357.7,521.1,358.1z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M467.7,320.7c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0.1C467.7,320.6,467.7,320.6,467.7,320.7z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M468.5,333.1L468.5,333.1l-3.2,3.9c0,0,2.5-14.5,2.4-16.3C467.8,322.1,468.8,330,468.5,333.1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M490.1,287.8c0,0-6.7,9-7.1,25.5s5.5,86.4,4.7,96.8c0,0,14.5-5.5,18.3-8.5s-6.6-52.9-7.9-57.5s-3.9-19,7.9-41 c0,0-2.5-11-7.5-12.9C495.9,289,493,288.2,490.1,287.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M524.6,354.7c-1.9-6.4-6.1-18.7-6.9-21.2c-2.1-6.7-3.2-8.2-6.2-17.2c-1.2-3.5-3.6-9.1-5.4-13.2l0,0 c-1.1-4.2-3.1-8.1-6-11.4c-1.9-2.1-7.2-2.9-7.2-2.9s0.7,1,1.8,2.4c-0.4,0-0.7,0-1.1,0.1c-7.1,1.8,1,13.6,1.6,15.1s10.7,19,11.5,20.6 c2.5,5.5,4,6.8,6,11.9c2.6,7,6.8,13.9,8.9,17.7C522.4,358.2,525.3,357.1,524.6,354.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M479.3,288.6c0,0-6.2,6.8-7.1,20.4s-1.5,29.7-3.7,43.7S463,412,463,412s-4.8-3.6-5.7-5.9s2.5-44.5,6.6-56.2 s5.1-13.4,3.9-23.6s-3.6-14.5-3-18.3S471.5,291.3,479.3,288.6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M126.1,278.7c0,0,2.4-4.2-1.4-15.6c-1.7-6.1-8.1-9.6-14.1-7.8c-2.7,0.8-5,2.5-6.5,4.8 c-4.1,7-2.7,11.4,3.3,19.3S123.6,282.4,126.1,278.7z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M96.3,473.8c0,0-0.6,4.7-0.7,5.4s-7.1-0.4-7.1-0.4l-0.6-5.5C88,473.2,95.4,473.2,96.3,473.8z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M95.6,478.6c1.2,1.6,2.7,2.9,4.3,4c2.1,1.2,5.5,1.7,6.8,3c0.9,0.9,3.3,4.9-5.6,4.8S88,491,87,489.4 s1.4-11.1,1.4-11.1C90.8,478.8,93.2,478.9,95.6,478.6z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M144.6,473.8c0,0-0.6,4.7-0.7,5.4s-7.1-0.4-7.1-0.4l-0.6-5.5C136.3,473.2,143.8,473.2,144.6,473.8z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M144,478.6c1.2,1.6,2.7,2.9,4.4,4c2.1,1.2,10,2.2,11.3,3.5c0.9,0.9,2.4,4.6-10.1,4.2c-8.9-0.2-13.2,0.6-14.1-1 s1.4-11.1,1.4-11.1C139.2,478.6,141.6,478.7,144,478.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M98.6,357.9c0,0-3.6,11.1-3.1,20.7s-1.8,20.1-2.8,30.1c-1.1,11.2-5.4,37.6-5.6,43.6s-1.7,24.5-1.7,24.5l11,0.8 c0,0,7.3-46.2,9.2-51s11.2-38.4,11.6-42.1S98.6,357.9,98.6,357.9z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M134.6,356.7c0,0,5.3,29.4,5.9,35.3s1.1,28.4,1.4,32.1s2.1,48,3.8,53.5h-11.8c0,0-7.8-32.2-7.8-47.5 s-6.6-33.2-10.8-43.2s-14-10.3-16.6-29C98.6,357.9,131,350.8,134.6,356.7z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 257,
    transform: "matrix(0.5727 -0.8198 0.8198 0.5727 -141.5928 244.0483)",
    className: "st44",
    width: 22.5,
    height: 1.7
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M122.6,281.7c0,0-1.1,3.2,0,5.4c1.1,2.3-14,0.9-14,0.9c0.4-2.9-0.1-5.9-1.3-8.5 C105.4,275.7,122.6,281.7,122.6,281.7z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M97.9,360.3c0,0,5.4,5.6,37.2-0.9l-0.5-2.7l-36.1,1.4L97.9,360.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M174.3,253.6c0.1,0.5,0.2,1,0.1,1.6c0,0-0.3,0.9-0.5,1.6c0,0.2-0.1,0.3-0.1,0.5c0,1-0.2,1.9-0.6,2.8 c-0.5,1.2-2.7,5.2-2.7,5.2l-3.7-1.2l-3.4-0.1c0,0-1.2-7.7-0.9-8.8c0-0.1,0.1-0.2,0.1-0.3c0.4-0.7,0.8-1.4,1.3-2 c0.1-0.2,1.1-1.8,1.7-1.9c0.7-0.1,1.3,0.1,1.8,0.6c0.9-0.1,1.7,0.1,2.5,0.5c0.9-0.1,1.8,0.3,2.4,0.9 C172.4,252.7,173.9,252.7,174.3,253.6z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M171.5,263.6c-1.2,4.9-2.3,9.7-3.5,14.6c-0.8,5.5-3.1,8.7-4.4,10.3c-3,3.6-7.2,5.3-12.7,8 c-1.6,0.8-3.2,1.4-4.9,2c-5.1,1.7-9.9,3.9-14.4,6.7H93.4c0.6-5.5,2.3-10.9,4.8-15.9c2.9-0.2,7.3-0.7,9.5-0.8 c1.9-0.2,3.9-0.6,5.7-1.3l1,0.1l2.9,0.2l7.5,0.5c0,0,5.6,0.6,7.1,0.9s12.3-1.9,14.5-2.1c0.5,0,0.7-0.2,1.1-0.3 c5.3-1.8,8.7-4.7,10.8-7.1c1.8-5.4,3.5-10.7,5.3-16.1C166.2,263.3,168.9,263.4,171.5,263.6z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M98.6,288.5c0,0-4.1,0-13.1,28.4c-3.1,9.8,14.2,17.3,14.2,17.3L98.6,288.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M93,311.6L93,311.6c1.5,6.5,2.7,13.2,3.5,19.8c0.6,5.9-4.3,44.5-4.3,44.5c4.9,3.8,48.1,4.8,47.8,3.2 s-7.3-46.4-6.4-49.5c1.5-5.8,2.6-11.7,3.2-17.7c0.5-5.7,5.4-9,5.4-9l8.6-6.6c0.9-4.2-3.4-10.1-3.4-10.1s-13,1.4-14.7,1.2 c-1.5-0.2-10.4-1.2-10.4-1.2c-1.6,0.5-3.3,0.9-5.1,1.1c-1,0.1-2,0.1-2.9-0.2c-0.4-0.1-0.7-0.3-0.9-0.5c0,0-9.7,0.4-14.8,1.8 C94.3,295.4,92.3,303.5,93,311.6z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M107.3,279.6c0,0,2,0.2,6.2-1.3s4.5-8.9,5.5-8c1,1.1,2.7,1.2,3.8,0.2c0.2-0.2,0.4-0.4,0.6-0.7 c0,0-2.1-2.7-1.1-4c0.7-0.9,1.6-1.7,2.5-2.3c0,0-3-14.4-16.5-7.8C92.4,263.3,107.3,279.6,107.3,279.6z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M122.6,287.2l-0.5-2.1c-4.5-0.1-8.9,0.1-13.4,0.5l-0.5,2.5C108.2,288.1,114.3,290.8,122.6,287.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M120.4,268.5c-0.8-1.3-3.7-2.2-4,1.5c-0.3,2.9,5.2,6,5.2,3.3C121.8,271.6,121.3,269.9,120.4,268.5z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "170.3,249.1 170.7,247.1 168.9,248.1 "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M98.6,288.5c0,0-12.6,8.8-13.1,28.4l9.6,2.1L98.6,288.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/signIn.3f3ccadfafea0683cb6ad5e4e4681f1c.svg";
export { ForwardRef as ReactComponent };